import React from 'react';

import { downloadData } from 'aws-amplify/storage';
import AnimatedImage from './AnimatedImage';

async function get_image(src) {
    try {
        //console.log(`S3Image: Downloading image from src: ${src}`);
        const result = await downloadData({
            path: src,
            options: { resource: 'upload' }
        }).result;
        return result
    } catch (error) {
        console.log(`Error: ${error}`);
    }
}

function S3Image({ src, boardHeight, scale, sx, onClick, tick }) {

    const [imageData, setImageData] = React.useState(null);

    React.useEffect(() => {
        async function fetchImage() {
            const data = await get_image(src);
            if (data && data.body) {
                const blob = await data.body.blob();
                setImageData(URL.createObjectURL(blob));
            }
        }
        fetchImage();
    }, [src]);

    return <AnimatedImage src={imageData} boardHeight={boardHeight} scale={scale} sx={sx} onClick={onClick} tick={tick} />;
}

export default S3Image;